import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl, FormBuilder, AbstractControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { ModalCustomOptions } from '@app/models';
import { GpsV2Service, UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { BankAccount } from '@interfaces/app';
import { SafeHtml } from '@angular/platform-browser';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
   selector: 'mnf-user-direct-debit',
   templateUrl: './user-direct-debit.component.html',
   styleUrls: ['./user-direct-debit.component.scss']
})
export class UserDirectDebitComponent implements OnInit {
   balance: number;
   wdForm: FormGroup;
   totalAccounts: number;
   bankAccounts: BankAccount[];
   modalOTPConf = {
      header: 'Retiro de fondos',
      title: 'Verificación de retiro',
      message: `Ingresa el <span class="cl-primary-7">Token</span> que ha sido enviado ${this.userServ.otpMethod === 'sms' ? 'por SMS' : 'a tu correo electrónico'}`
   };

   // Formulario
   domForm: FormGroup;

   // Variables para cambiar la información del plan
   changeInfoPlan: boolean = false;

   // Mostrar información de ayuda
   currentParagraph: number | null = 1;

   // Iconos
   iconCheck = faCheckCircle;
   iconTimes = faTimesCircle;

   // Arreglo de valores de frencuencia
   frecuencyPay = [
      { value: 'firstDay', viewValue: 'Cada primer día del mes' },
      { value: 'halfDay', viewValue: 'Cada día 16 del mes' },
      { value: 'firstAndHalfDay', viewValue: 'Primer día del mes y día 16 del mes' }
   ]

   // Información del usuario
   u: any;

   // Información de domiciliación
   domiciliationActive: any;

   // Información del arreglo de planes
   selectedPlan: any;

   /** Contrato */
   contractTemplate: SafeHtml;

   constructor(
      private modal: MatDialogRef<UserDirectDebitComponent>,
      private userServ: UserService,
      private modalServ: ModalService,
      private toastrServ: ToastrService,
      private fb: FormBuilder,
      private gpsServ: GpsV2Service,
      private toastServ: ToastrService
   ) { }

   ngOnInit(): void {
      this.domForm = this.fb.group({
         frecuency: ['', Validators.compose([Validators.required])],
         clabe: ['', Validators.compose([Validators.required])],
         amount: ['', Validators.compose([Validators.required, Validators.min(500), Validators.max(60000), Validators.maxLength(18)])],
         plan: ['Selecciona tu plan', Validators.compose([Validators.required, this.planValidator])]
      });

      this.userServ.getBankAccounts().subscribe(ba => {
         this.bankAccounts = ba;
         this.totalAccounts = ba.length;
      });

      this.userServ.getUserInf().subscribe(u => {
         this.u = u;
      })

      this.userServ.getInfoDomiciliation().subscribe(domiciliationActive => {
         this.domiciliationActive = domiciliationActive;
      })

      // Resetear el campo de plan en caso de modificar el valor de monto
      this.domForm.get('amount').valueChanges.subscribe(val => {
         this.domForm.get('plan').setValue('Selecciona tu plan');
      })

   }

   close() {
      this.modal.close();
   }

   /** Cambiar la información del plan */
   toggleActive() {
      this.changeInfoPlan = !this.changeInfoPlan;

      // Bloquear / Desbloquear campa de plan
      if(this.changeInfoPlan) {
         this.domForm.get('plan').disable();
      } else {
         this.domForm.get('plan').enable();
      }
      // Reiniciar formulario
      this.domForm.reset({
         frecuency: '',
         clabe: '',
         amount: '',
         plan: 'Selecciona tu plan'
      });
   }

   /** Enviar información para guardar la domiciliación */
   saveInfo() {
      if(!this.domForm.invalid) {
         const infoForm = this.domForm.value;

         const conf: ModalCustomOptions = {
            header: 'Domiciliar CLABE',
            title: '¿Seguro de continuar?',
            message: `Vas a domiciliar mensualmente un monto total de <span class="cl-primary-7">$${infoForm.amount.toFixed(2)} MXN</span> 
               desde tu cuenta CLABE: <span class="cl-primary-7">**** ${infoForm.clabe.clabe} - ${infoForm.clabe.bankName}</span> a tu cuenta Monific`,
            buttonText: 'Aceptar',
            cancelText: 'Cancelar'
         };

         const m = this.modalServ.modalCustom(conf);
         
         m.beforeClosed().subscribe(accept => {
            if(accept) {
               if(this.domiciliationActive != null) {
                  const m = this.modalServ.openModalVerifyPassword(this.u?.email);

                  m.afterClosed().subscribe(r => {
                     if (r) {
                       const gps = this.gpsServ.getCoordinatesFromLocalStorage();
                   
                       const executeContractFlow = () => {
                         const infoToSend = { 
                           bankName: infoForm.clabe.bankName,
                           amountToRecollect: infoForm.amount.toString(), 
                           clabe: infoForm.clabe.clabe,
                           typePlan: this.changeInfoPlan ? 'Standard' : 'Premium',
                           frecuency: infoForm.frecuency.value,
                           totalMonths: this.selectedPlan?.plan?.totalMonths,
                           idBank: infoForm.clabe.id
                         };
                   
                         this.userServ.signatureContractDomiciliation(infoToSend).subscribe(r => {
                           if (r) {
                             this.userServ.createDirectDebit(infoToSend).subscribe({
                               next: (r) => {
                                 const m = this.modalServ.openModalConfirmDomiciliation(r);
                   
                                 m.afterClosed().subscribe(() => {
                                   location.reload();
                                 });
                               },
                               error: err => {
                                 if (err.error?.err !== 'TS01') {
                                   this.toastrServ.warning(err.error?.msg);
                                 }
                               }
                             });
                           } else {
                             this.toastServ.warning('No se pudo firmar el contrato de domiciliación.');
                           }
                         });
                       };
                   
                       if (gps) {
                         executeContractFlow();
                       } else {
                         this.gpsServ.defineGPS().subscribe((r) => {
                           if (r) {
                             executeContractFlow();
                           } else {
                             this.toastrServ.warning('No se pudo obtener la ubicación para continuar.');
                           }
                         });
                       }
                     }
                   });
                   

               } else {
                  this.modalServ.openContractDomiciliation(infoForm.frecuency, infoForm.clabe.bankName, infoForm.clabe.clabe, infoForm.amount, this.u, this.changeInfoPlan, this.selectedPlan?.plan?.totalMonths, infoForm.clabe.id);
               }
            } else {
               this.toastrServ.info('Operación cancelada');
            }
         })

      }
   }

   /** Cambiar de sección de ayuda */
   showParagraph(paragraphNumber: number): void {
      this.currentParagraph = paragraphNumber;
   } 

   /** Mostrar modal para calcular rendimientos por años */
   openModalCalculate() {
      if(!this.changeInfoPlan) {
         const amount = this.domForm.get('amount').value;
         if(amount == null || amount == '') {
            this.toastrServ.warning('Ingresa un monto para calcular los rendimientos');
         } else if(amount < 500) {
            this.toastServ.warning('El monto minimo a domiciliar es de $500 MXN')
         }else {
            const m = this.modalServ.openModalViewGraph(amount);

            m.componentInstance.planSelectedEvent.subscribe((data: any) => {

               // Asignar información del modal a la variable del plan seleccionado
               this.selectedPlan = data;

               // Asignar valor de plan seleccionado
               const plan = this.domForm.get('plan');
               plan.setValue(data.plan.text);

               this.toastrServ.success('Has seleccionado el plan de ' + data.plan.text);
            })

         }
      }         
   }

   /** Validar que selecciono un plan */
   planValidator(control: AbstractControl): { [key: string]: boolean } | null {
      if (control.value === 'Selecciona tu plan') {
          return { 'defaultSelected': true };
      }
      return null;
  }

}